import { render, staticRenderFns } from "./AggregationView.vue?vue&type=template&id=5ddb5ed4"
import script from "./AggregationView.vue?vue&type=script&lang=js"
export * from "./AggregationView.vue?vue&type=script&lang=js"
import style0 from "./AggregationView.vue?vue&type=style&index=0&id=5ddb5ed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports